// import { createApp } from 'vue'
// import { createPinia } from 'pinia'
// import App from './App.vue'
// import router from './router'
// // import UIPlugins from '@ui-kit/base-ui'
// import './assets/css/tailwind.css'

// const app = createApp(App)

// app.use(createPinia())
// app.use(router)
// // app.use(UIPlugins)
import "reflect-metadata";

// app.mount('#app')
// import '@/styles/element/index.scss'
import "element-plus/dist/index.css";
import "@/styles/main.scss";
import "@/assets/css/tailwind.scss";

async function initApplication() {
  const { bootstrap } = await import("./bootstrap");
  await bootstrap("namespace");
}

initApplication();
